import CollapseAll from "../icons/CollapseAll";
import ExpandAll from "../icons/ExpandAll";

import {
  ButtonSizes,
  ButtonTypes,
  IconTypes,
  StyledButton,
} from "@/components/StyledButton";

type AccordionToggleButtonProps = {
  handleClick: () => void;
  shouldCollapse: boolean;
};

export const ComponentSkillsAccordionToggleButton = ({
  handleClick,
  shouldCollapse,
}: AccordionToggleButtonProps) => {
  return (
    <StyledButton
      buttonType={ButtonTypes.Tertiary}
      size={ButtonSizes.Small}
      iconType={IconTypes.Only}
      className="medium:w-auto medium:py-3.5 medium:pl-3 medium:pr-4"
      onClick={handleClick}
    >
      {shouldCollapse ? <CollapseAll /> : <ExpandAll />}
      <span className="hidden text-base font-semibold text-BG-60 medium:inline">
        {shouldCollapse ? "Collapse All" : "Expand All"}
      </span>
    </StyledButton>
  );
};
